import { useDispatch, useSelector } from 'react-redux';

import { HelpChatSliceState } from '@hcs/types';
import { mapDispatchToSliceActions } from '@hcs/utils';

import {
  HELP_CHAT_REDUCER_KEY,
  HelpChatPartialAppState,
  helpChatSlice,
} from '../rtk';

export const useHelpChatSlice = () => {
  const dispatch = useDispatch();

  return {
    state: useSelector<HelpChatPartialAppState, HelpChatSliceState | undefined>(
      (state) => state[HELP_CHAT_REDUCER_KEY],
    ),
    actions: mapDispatchToSliceActions(dispatch, helpChatSlice),
  };
};
